// third-party
import { FormattedMessage } from "react-intl";

// assets
import { Bookmark } from "iconsax-react";

// type
import { NavItemType } from "types/menu";

// icons
const icons = {
  subscription: Bookmark,
};

// ==============================|| MENU ITEMS - WIDGETS ||============================== //

const subscription: NavItemType = {
  id: "group-subscription",
  title: <FormattedMessage id="page.menu_items_subscription_label" />,
  icon: icons.subscription,
  type: "group",
  children: [
    {
      id: "subscription",
      title: <FormattedMessage id="page.menu_items_subscription_label" />,
      type: "item",
      url: "/subscription",
      icon: icons.subscription,
    },
  ],
};

export default subscription;
